import { render } from "./PureColorBackground.vue?vue&type=template&id=bc3a91d0&scoped=true"
import script from "./PureColorBackground.vue?vue&type=script&lang=js"
export * from "./PureColorBackground.vue?vue&type=script&lang=js"

import "./PureColorBackground.vue?vue&type=style&index=0&id=bc3a91d0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3a91d0"]])

export default __exports__